/**
 * CANsense API Client Helpers
 *
 * Shared utility functions used by all CANsense API service files.
 */

/**
 * Helper function to determine API base URL based on environment
 */
export const getApiBaseUrl = (): string => {
  return process.env.NODE_ENV !== 'production'
    ? 'http://localhost:10000/api3.2'
    : '/api3.2';
};

/**
 * Helper function to get X-Forwarded-Host header for multitenancy
 */
export const getForwardedHost = (apiUrl: string): string => {
  try {
    const parsedUrl = apiUrl.startsWith('http')
      ? new URL(apiUrl)
      : new URL(apiUrl, window.location.origin);
    return parsedUrl.host;
  } catch (error) {
    return window.location.host;
  }
};
